var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCornerSquared(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_corner_squared") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_corner_squared",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_shape_rectangle_squared"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.223880597 L0.223048327,60 L1.56133829,60 L58.8847584,60 C59.5539033,60 60,59.5522388 60,58.880597 L60,58.880597 L60,0 L0,0.223880597 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.66171,1.11940299 L58.66171,59.1044776 L1.33828996,59.1044776",
    id: "Path",
    stroke: "#BABABA",
    strokeWidth: 2.23048327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10.6059482106489,7.070632140432598"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#505050",
    fillRule: "nonzero",
    points: "59.7769517 2.23880597 2.23048327 2.23880597 2.23048327 60 0 60 0 0 59.7769517 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCornerSquared);
export default __webpack_public_path__ + "static/media/icon-corner-squared.0293bca29104e9b0fb69adfb4c693ef5.svg";
export { ForwardRef as ReactComponent };